import React from "react";
import DocumentManagement from "../DocumentManagement";
import { Container, Row } from "reactstrap";
import { Typography } from "@mui/material";
import { Icon } from "@progress/kendo-react-common";

const JacketManagement = () => {
  return (
    <Container fluid={true}>
      <Row className="bg-primary rounded py-3 mb-3">
        <Typography variant="h5">
          <Icon style={{ fontSize: "25px", margin: "10px" }} name="file-data" />
          HR Jacket Management
        </Typography>
      </Row>
      <DocumentManagement jacket={true}/>
    </Container>
  );
};

export default JacketManagement;
